export const isFullUrl = (url) => {
  return /^(http|https):\/\/[^ "]+$/.test(url)
}

export const getUrlTarget = (url) => {
  if (isFullUrl(url)) return '_blank'

  return '_self'
}
